<app-resource-form-card
  [title]="service.title()"
  [resource]="service.resource"
  [createButton]="access()?.role?.actions?.create"
  [list]="true"
  [(detailed)]="detailed">
  @defer (when value()) {
    <p-table
      [value]="value()"
      [paginator]="true"
      [rows]="5"
      [rowsPerPageOptions]="[5, 10, 20]"
      [scrollable]="true"
      scrollHeight="flex">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th pSortableColumn="name" class="min-w-32">
            Nombre <p-sortIcon field="name" />
          </th>
          @if (detailed()) {
            <th class="min-w-32">
              Descripción
            </th>
            <th pSortableColumn="permissions" class="min-w-32">
              Permisos <p-sortIcon field="permissions" />
            </th>
            @if (access()?.contract?.actions?.read) {
              <th pSortableColumn="contract.name" class="min-w-32">
                Contrato <p-sortIcon field="contract.name" />
              </th>
            }
          }
          <th class="action">
            Acciones
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-value>
        <tr>
          <td>{{ value.name }}</td>
          @if (detailed()) {
            <td>{{ value.description }}</td>
            <td>
              @if (value.permissions) {
                @for (permission of value.permissions; track $index) {
                  <p-chip [label]="$index + 1 + ' - ' + permission.name"/>
                }
              } @else {
                {{ 'El rol no tiene permisos asignados' }}
              }
            </td>
            @if (access()?.contract?.actions?.read) {
              <td>{{ value.contract?.name ?? 'El Rol no tiene un contrato asignado' }}</td>
            }
          }
          <td>
            <app-resource-button-group
              [resource]="service.resource"
              [resourceId]="value._id"
              [detailsButton]="true"
              [editButton]="access()?.role?.actions?.update"
              [deleteButton]="access()?.role?.actions?.delete"
              [iconOnly]="true">
            </app-resource-button-group>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</app-resource-form-card>
